import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import checkresponseReducer from 'slices/checkresponseSlice'
import driverSendReducer from 'slices/driverSendSlice'
import finishdeliveryReducer from 'slices/finishdeliverySlice'
import startdeliveryReducer from 'slices/startdeliverySlice'

export const store = configureStore({
  reducer: {
    checkresponse: checkresponseReducer,
    driverSend: driverSendReducer,
    finishdelivery: finishdeliveryReducer,
    startdelivery: startdeliveryReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootStateType = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootStateType, unknown, Action<string>>
